module.exports = __webpack_public_path__ + "static/media/manager-guide-icon-support.91e1f0fa.svg";